import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AppConfig} from '../_helpers/appconfig.service';
import { Debtor } from '../_models/debtor.interface';
import { Address } from '../_models/address.interface';
import { Account } from '../_models/account.interface';
@Injectable()
export class DebtorService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();
    
    httpOptions:any;

    asyncCreateDebtorResult:any;
    
    constructor(private http: HttpClient) {

        let token = sessionStorage.getItem("currentUser");
         this.httpOptions = {
             headers: new HttpHeaders({                         
                 "Authorization": "Bearer " + token,
                 'Content-Type':  'application/json'
             })
             };

    }//end

    /**
     * get_debtor
     * Get a Debtor
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDebtor(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getDebtor.');
        }

        return this.http.get<Debtor>(`${this. _kcmssvcURL}/debtors/${encodeURIComponent(String(publicId))}`
        ,
            {
             
                observe: observe,
              
            }
        );
    }

    
getIndDebtorDetails(debPublicID : string): Observable<any> {  
    return this.http.get(`${this._kcmssvcURL}/debtors/`+debPublicID)
     .pipe(map(res => res)             
     );
 }//end

 public createDebtor(debtor: Debtor): Observable<any> {
    if (debtor === null || debtor === undefined) {
        throw new Error('Required parameter debtor was null or undefined when calling create Debtor.');
    }

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
   
    return this.http.post<Debtor>(`${this._kcmssvcURL}/debtors`, 
    debtor,
        {    
            observe: 'response',    
            headers: headers           
        }
    );
} // End

public updateDebtor(publicId: string, observe: any = 'body' ): Observable<any> {
    if (publicId === null || publicId === undefined) {
    throw new Error('Required parameter public Id was null or undefined when calling updateDebtor.');
    } 
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    
    
    return this.http.patch(`${this._kcmssvcURL}/debtors/${encodeURIComponent(String(publicId))}`, observe, {observe: 'response',headers: headers   })
    .pipe(map(response => {
   
    return response;
    }, err => {
    throw err;
    }));
    
    } // End

/**
     * get_debtor_invoice_list
     * Get Invoice List by Debtor
     * @param publicId 
     * @param limit 
     * @param start 
     * @param end 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDebtorInvoiceList(publicId: string, limit?: number, start?: number, end?: number, status?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getDebtorInvoiceList.');
        }

        return this.http.get(`${this._kcmssvcURL}/debtors/${encodeURIComponent(String(publicId))}/invoices`,
            {
                observe: observe,
                reportProgress: reportProgress
            }
            )
            .pipe(map(res => res)
        );

    }//end



    /**
     * get_debtor_invoice_list Filters with status = New
     * Get Invoice List by Debtor
     * @param publicId 
     * @param limit 
     * @param start 
     * @param end 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDebtorInvoiceListWithFilters(publicId: string, limit?: number, start?: number, end?: number, status?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getDebtorInvoiceList.');
        }

        return this.http.get(`${this._kcmssvcURL}/debtors/${encodeURIComponent(String(publicId))}/invoices?status=(1,8)`,
            {
                observe: observe,
                reportProgress: reportProgress
            }
            )
            .pipe(map(res => res)
        );

    }//end





    /**
     * Get Debtors Account List
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
        public getDebtorAccountList(publicId: string , observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
            return this.http.get<Array<Account>>(`${this._kcmssvcURL}/debtors/${encodeURIComponent(String(publicId))}/accounts`,
            {
                observe: observe,
                reportProgress: reportProgress
            }
            )
            .pipe(map(res => res)
            );
        }//end



     /**
     * Search Debtor
     * Get Search Debtor List by by email, creditor public_id
     */
    public searchDebtor(publicId: string, email?: string, external_id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getDebtorInvoiceList.');
        }

        var body1={
            "creditor": { "public_id": publicId },
           "external_id": external_id,
            "email": external_id,
            "document_id": external_id,
            "phone": external_id,
          }

        return this.http.post<Debtor>(`${this._kcmssvcURL}/debtors/search`,
            body1,
            {
              observe: observe,
            }
        )
        .pipe(map(res => res)
        );

    }//end

    public async  createDebtorPromise(debtor: Debtor) {
        if (debtor === null || debtor === undefined) {
            throw new Error('Required parameter debtor was null or undefined when calling create Debtor.');
        }
    
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        
        return await this.http.post<any>(`${this._kcmssvcURL}/debtors`, 
        debtor,
            {    
                observe: 'response',    
                headers: headers           
            }
        ).toPromise();

    } // End
    
    public async  searchDebtorPromise(publicId: string, email?: string, external_id?: string, observe: any = 'body', reportProgress: boolean = false) {
        
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Debtor List.');
        }
    
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return await this.http.get<any>(`${this._kcmssvcURL}/debtors/${external_id}?search_by=EXTERNAL_ID&customer_id=${publicId}`,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();

    } // End
    
}//end class


